var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ds-list"
  }, [(!!_vm.formConfig.dataSources && (_vm.formConfig.dataSources.length > 0)) ? _vm._l((_vm.formConfig.dataSources), function(ds, dsIdx) {
    return _c('el-descriptions', {
      key: dsIdx,
      attrs: {
        "column": 1,
        "size": "small",
        "border": ""
      },
      scopedSlots: _vm._u([{
        key: "title",
        fn: function() {
          return [_c('span', {
            attrs: {
              "title": ds.description
            }
          }, [_vm._v(_vm._s(ds.uniqueName))])]
        },
        proxy: true
      }, {
        key: "extra",
        fn: function() {
          return [_c('el-button', {
            attrs: {
              "type": "primary",
              "icon": "el-icon-edit",
              "plain": "",
              "circle": "",
              "size": "mini"
            },
            on: {
              "click": function($event) {
                return _vm.editDataSource(dsIdx)
              }
            }
          }), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "danger",
              "icon": "el-icon-delete",
              "plian": "",
              "circle": "",
              "size": "mini"
            },
            on: {
              "click": function($event) {
                return _vm.deleteDataSource(dsIdx)
              }
            }
          })]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _vm._v(" "), _c('el-descriptions-item', [_c('template', {
      slot: "label"
    }, [_c('i', {
      staticClass: "el-icon-s-platform",
      attrs: {
        "title": ds.requestURL
      }
    })]), _vm._v("\n        " + _vm._s(ds.requestURL) + "\n      ")], 2)], 1)
  }) : [_c('el-empty', {
    attrs: {
      "description": _vm.i18nt('designer.setting.noDataSource')
    }
  })], _vm._v(" "), _c('div', {
    staticClass: "ds-button-wrapper"
  }, [_c('el-button-group', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-plus",
      "plain": ""
    },
    on: {
      "click": _vm.addDataSource
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18nt('designer.setting.addDataSource')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-bottom-left",
      "plain": "",
      "title": _vm.i18nt('designer.setting.importDataSource')
    },
    on: {
      "click": _vm.importDataSource
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-top-right",
      "plain": "",
      "title": _vm.i18nt('designer.setting.exportDataSource')
    },
    on: {
      "click": _vm.exportDataSource
    }
  })], 1)], 1), _vm._v(" "), (_vm.showDataSourceDialogFlag) ? _c('el-drawer', {
    attrs: {
      "direction": "rtl",
      "modal": true,
      "size": 820,
      "show-close": false,
      "visible": _vm.showDataSourceDialogFlag,
      "destroy-on-close": true,
      "append-to-body": true,
      "wrapperClosable": false,
      "close-on-press-escape": false,
      "custom-class": "ds-setting-drawer header-small-mb"
    },
    on: {
      "update:visible": function($event) {
        _vm.showDataSourceDialogFlag = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function() {
        return [_c('div', [_vm._v(_vm._s(_vm.i18nt('designer.setting.dataSourceSetting')))]), _vm._v(" "), _c('div', {
          staticStyle: {
            "float": "right"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "plain": ""
          },
          on: {
            "click": _vm.testDataSource
          }
        }, [_vm._v("\n          " + _vm._s(_vm.i18nt('designer.setting.testDataSource')))]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": _vm.saveDataSource
          }
        }, [_vm._v("\n          " + _vm._s(_vm.i18nt('designer.setting.saveDataSource')))]), _vm._v(" "), _c('el-button', {
          on: {
            "click": function($event) {
              _vm.showDataSourceDialogFlag = false
            }
          }
        }, [_vm._v("\n          " + _vm._s(_vm.i18nt('designer.hint.cancel')))])], 1)]
      },
      proxy: true
    }, {
      key: "default",
      fn: function() {
        return [_c('el-form', {
          ref: "dsForm",
          staticClass: "ds-form",
          attrs: {
            "model": _vm.dsModel,
            "rules": _vm.formRules,
            "label-width": "160px",
            "label-position": "left"
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": _vm.i18nt('designer.setting.dsUniqueName'),
            "prop": "uniqueName"
          }
        }, [_c('el-input', {
          model: {
            value: (_vm.dsModel.uniqueName),
            callback: function($$v) {
              _vm.$set(_vm.dsModel, "uniqueName", $$v)
            },
            expression: "dsModel.uniqueName"
          }
        })], 1), _vm._v(" "), _c('el-row', {
          staticStyle: {
            "width": "100%"
          }
        }, [_c('el-col', {
          attrs: {
            "span": 20
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": _vm.i18nt('designer.setting.dsRequestURL'),
            "prop": "requestURL"
          }
        }, [_c('el-input', {
          model: {
            value: (_vm.dsModel.requestURL),
            callback: function($$v) {
              _vm.$set(_vm.dsModel, "requestURL", $$v)
            },
            expression: "dsModel.requestURL"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 4
          }
        }, [_c('el-form-item', {
          staticClass: "no-left-margin",
          attrs: {
            "label-width": "0",
            "prop": "requestURLType"
          }
        }, [_c('el-select', {
          attrs: {
            "placeholder": _vm.i18nt('designer.setting.dsRequestURLType')
          },
          model: {
            value: (_vm.dsModel.requestURLType),
            callback: function($$v) {
              _vm.$set(_vm.dsModel, "requestURLType", $$v)
            },
            expression: "dsModel.requestURLType"
          }
        }, [_c('el-option', {
          attrs: {
            "label": _vm.i18nt('designer.setting.dsURLStringType'),
            "value": "String"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": _vm.i18nt('designer.setting.dsURLVariableType'),
            "value": "Variable"
          }
        })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": _vm.i18nt('designer.setting.dsDescription'),
            "prop": "description"
          }
        }, [_c('el-input', {
          attrs: {
            "type": "textarea",
            "rows": 2
          },
          model: {
            value: (_vm.dsModel.description),
            callback: function($$v) {
              _vm.$set(_vm.dsModel, "description", $$v)
            },
            expression: "dsModel.description"
          }
        })], 1), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": _vm.i18nt('designer.setting.dsRequestMethod'),
            "prop": "requestMethod"
          }
        }, [_c('el-radio-group', {
          model: {
            value: (_vm.dsModel.requestMethod),
            callback: function($$v) {
              _vm.$set(_vm.dsModel, "requestMethod", $$v)
            },
            expression: "dsModel.requestMethod"
          }
        }, [_c('el-radio-button', {
          attrs: {
            "label": "get"
          }
        }, [_vm._v("get")]), _vm._v(" "), _c('el-radio-button', {
          attrs: {
            "label": "post"
          }
        }, [_vm._v("post")]), _vm._v(" "), _c('el-radio-button', {
          attrs: {
            "label": "put"
          }
        }, [_vm._v("put")]), _vm._v(" "), _c('el-radio-button', {
          attrs: {
            "label": "delete"
          }
        }, [_vm._v("delete")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": _vm.i18nt('designer.setting.dsRequestHeaders')
          }
        }, [_vm._l((_vm.dsModel.headers), function(rh, hIdx) {
          return _c('el-row', {
            key: hIdx,
            staticClass: "rh-row",
            attrs: {
              "gutter": 8
            }
          }, [_c('el-col', {
            attrs: {
              "span": 7
            }
          }, [_c('el-form-item', {
            attrs: {
              "prop": 'headers.' + hIdx + '.name',
              "rules": _vm.nameRules,
              "label-width": "0"
            }
          }, [_c('el-input', {
            attrs: {
              "placeholder": _vm.i18nt('designer.setting.dsRequestNameInputPlaceholder')
            },
            model: {
              value: (rh.name),
              callback: function($$v) {
                _vm.$set(rh, "name", $$v)
              },
              expression: "rh.name"
            }
          })], 1)], 1), _vm._v(" "), _c('el-col', {
            attrs: {
              "span": 5
            }
          }, [_c('el-form-item', {
            attrs: {
              "prop": 'headers.' + hIdx + '.type',
              "label-width": "0"
            }
          }, [_c('el-select', {
            attrs: {
              "placeholder": _vm.i18nt('designer.setting.dsRequestTypeInputPlaceholder')
            },
            model: {
              value: (rh.type),
              callback: function($$v) {
                _vm.$set(rh, "type", $$v)
              },
              expression: "rh.type"
            }
          }, [_c('el-option', {
            attrs: {
              "label": _vm.i18nt('designer.setting.dsRequestValueStringType'),
              "value": "String"
            }
          }), _vm._v(" "), _c('el-option', {
            attrs: {
              "label": _vm.i18nt('designer.setting.dsRequestValueNumberType'),
              "value": "Number"
            }
          }), _vm._v(" "), _c('el-option', {
            attrs: {
              "label": _vm.i18nt('designer.setting.dsRequestValueBooleanType'),
              "value": "Boolean"
            }
          }), _vm._v(" "), _c('el-option', {
            attrs: {
              "label": _vm.i18nt('designer.setting.dsRequestValueVariableType'),
              "value": "Variable"
            }
          })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
            attrs: {
              "span": 8
            }
          }, [_c('el-form-item', {
            attrs: {
              "prop": 'headers.' + hIdx + '.value',
              "rules": _vm.valueRules,
              "label-width": "0"
            }
          }, [_c('el-input', {
            attrs: {
              "placeholder": _vm.i18nt('designer.setting.dsRequestValueInputPlaceholder')
            },
            model: {
              value: (rh.value),
              callback: function($$v) {
                _vm.$set(rh, "value", $$v)
              },
              expression: "rh.value"
            }
          })], 1)], 1), _vm._v(" "), _c('el-col', {
            attrs: {
              "span": 3
            }
          }, [_c('el-button', {
            attrs: {
              "icon": "el-icon-delete",
              "plain": "",
              "circle": ""
            },
            on: {
              "click": function($event) {
                return _vm.deleteRequestHeader(hIdx)
              }
            }
          })], 1)], 1)
        }), _vm._v(" "), _c('el-row', [_c('el-col', {
          attrs: {
            "span": 6
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text",
            "icon": "el-icon-plus"
          },
          on: {
            "click": _vm.addRequestHeader
          }
        }, [_vm._v("\n                " + _vm._s(_vm.i18nt('designer.setting.addRequestHeader')))])], 1)], 1)], 2), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": _vm.i18nt('designer.setting.dsRequestParams')
          }
        }, [_vm._l((_vm.dsModel.params), function(rp, pIdx) {
          return _c('el-row', {
            key: pIdx,
            staticClass: "rd-row",
            attrs: {
              "gutter": 8
            }
          }, [_c('el-col', {
            attrs: {
              "span": 7
            }
          }, [_c('el-form-item', {
            attrs: {
              "prop": 'params.' + pIdx + '.name',
              "rules": _vm.nameRules,
              "label-width": "0"
            }
          }, [_c('el-input', {
            attrs: {
              "placeholder": _vm.i18nt('designer.setting.dsRequestNameInputPlaceholder')
            },
            model: {
              value: (rp.name),
              callback: function($$v) {
                _vm.$set(rp, "name", $$v)
              },
              expression: "rp.name"
            }
          })], 1)], 1), _vm._v(" "), _c('el-col', {
            attrs: {
              "span": 5
            }
          }, [_c('el-form-item', {
            attrs: {
              "prop": 'params.' + pIdx + '.type',
              "label-width": "0"
            }
          }, [_c('el-select', {
            attrs: {
              "placeholder": _vm.i18nt('designer.setting.dsRequestTypeInputPlaceholder')
            },
            model: {
              value: (rp.type),
              callback: function($$v) {
                _vm.$set(rp, "type", $$v)
              },
              expression: "rp.type"
            }
          }, [_c('el-option', {
            attrs: {
              "label": _vm.i18nt('designer.setting.dsRequestValueStringType'),
              "value": "String"
            }
          }), _vm._v(" "), _c('el-option', {
            attrs: {
              "label": _vm.i18nt('designer.setting.dsRequestValueNumberType'),
              "value": "Number"
            }
          }), _vm._v(" "), _c('el-option', {
            attrs: {
              "label": _vm.i18nt('designer.setting.dsRequestValueBooleanType'),
              "value": "Boolean"
            }
          }), _vm._v(" "), _c('el-option', {
            attrs: {
              "label": _vm.i18nt('designer.setting.dsRequestValueVariableType'),
              "value": "Variable"
            }
          })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
            attrs: {
              "span": 8
            }
          }, [_c('el-form-item', {
            attrs: {
              "prop": 'params.' + pIdx + '.value',
              "rules": _vm.valueRules,
              "label-width": "0"
            }
          }, [_c('el-input', {
            attrs: {
              "placeholder": _vm.i18nt('designer.setting.dsRequestValueInputPlaceholder')
            },
            model: {
              value: (rp.value),
              callback: function($$v) {
                _vm.$set(rp, "value", $$v)
              },
              expression: "rp.value"
            }
          })], 1)], 1), _vm._v(" "), _c('el-col', {
            attrs: {
              "span": 3
            }
          }, [_c('el-button', {
            attrs: {
              "icon": "el-icon-delete",
              "plain": "",
              "circle": ""
            },
            on: {
              "click": function($event) {
                return _vm.deleteRequestParam(pIdx)
              }
            }
          })], 1)], 1)
        }), _vm._v(" "), _c('el-row', [_c('el-col', {
          attrs: {
            "span": 6
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text",
            "icon": "el-icon-plus"
          },
          on: {
            "click": _vm.addRequestParam
          }
        }, [_vm._v("\n                " + _vm._s(_vm.i18nt('designer.setting.addRequestParam')))])], 1)], 1)], 2), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": _vm.i18nt('designer.setting.dsRequestData')
          }
        }, [_vm._l((_vm.dsModel.data), function(rd, dIdx) {
          return _c('el-row', {
            key: dIdx,
            staticClass: "rd-row",
            attrs: {
              "gutter": 8
            }
          }, [_c('el-col', {
            attrs: {
              "span": 7
            }
          }, [_c('el-form-item', {
            attrs: {
              "prop": 'data.' + dIdx + '.name',
              "rules": _vm.nameRules,
              "label-width": "0"
            }
          }, [_c('el-input', {
            attrs: {
              "placeholder": _vm.i18nt('designer.setting.dsRequestNameInputPlaceholder')
            },
            model: {
              value: (rd.name),
              callback: function($$v) {
                _vm.$set(rd, "name", $$v)
              },
              expression: "rd.name"
            }
          })], 1)], 1), _vm._v(" "), _c('el-col', {
            attrs: {
              "span": 5
            }
          }, [_c('el-form-item', {
            attrs: {
              "prop": 'data.' + dIdx + '.type',
              "label-width": "0"
            }
          }, [_c('el-select', {
            attrs: {
              "placeholder": _vm.i18nt('designer.setting.dsRequestTypeInputPlaceholder')
            },
            model: {
              value: (rd.type),
              callback: function($$v) {
                _vm.$set(rd, "type", $$v)
              },
              expression: "rd.type"
            }
          }, [_c('el-option', {
            attrs: {
              "label": _vm.i18nt('designer.setting.dsRequestValueStringType'),
              "value": "String"
            }
          }), _vm._v(" "), _c('el-option', {
            attrs: {
              "label": _vm.i18nt('designer.setting.dsRequestValueNumberType'),
              "value": "Number"
            }
          }), _vm._v(" "), _c('el-option', {
            attrs: {
              "label": _vm.i18nt('designer.setting.dsRequestValueBooleanType'),
              "value": "Boolean"
            }
          }), _vm._v(" "), _c('el-option', {
            attrs: {
              "label": _vm.i18nt('designer.setting.dsRequestValueVariableType'),
              "value": "Variable"
            }
          })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
            attrs: {
              "span": 8
            }
          }, [_c('el-form-item', {
            attrs: {
              "prop": 'data.' + dIdx + '.value',
              "rules": _vm.valueRules,
              "label-width": "0"
            }
          }, [_c('el-input', {
            attrs: {
              "placeholder": _vm.i18nt('designer.setting.dsRequestValueInputPlaceholder')
            },
            model: {
              value: (rd.value),
              callback: function($$v) {
                _vm.$set(rd, "value", $$v)
              },
              expression: "rd.value"
            }
          })], 1)], 1), _vm._v(" "), _c('el-col', {
            attrs: {
              "span": 3
            }
          }, [_c('el-button', {
            attrs: {
              "icon": "el-icon-delete",
              "plain": "",
              "circle": ""
            },
            on: {
              "click": function($event) {
                return _vm.deleteRequestData(dIdx)
              }
            }
          })], 1)], 1)
        }), _vm._v(" "), _c('el-row', [_c('el-col', {
          attrs: {
            "span": 6
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text",
            "icon": "el-icon-plus"
          },
          on: {
            "click": _vm.addRequestData
          }
        }, [_vm._v("\n                " + _vm._s(_vm.i18nt('designer.setting.addRequestData')))])], 1)], 1)], 2), _vm._v(" "), _c('el-tabs', {
          attrs: {
            "type": "border-card"
          },
          model: {
            value: (_vm.activeNames),
            callback: function($$v) {
              _vm.activeNames = $$v
            },
            expression: "activeNames"
          }
        }, [_c('el-tab-pane', {
          attrs: {
            "name": "1",
            "label": _vm.i18nt('designer.setting.dsConfigHandlerTitle')
          }
        }, [_c('el-alert', {
          attrs: {
            "type": "info",
            "closable": false,
            "title": "(config, isSandbox, DSV, VFR) => {"
          }
        }), _vm._v(" "), _c('code-editor', {
          ref: "chEditor",
          attrs: {
            "mode": 'javascript',
            "readonly": false
          },
          model: {
            value: (_vm.dsModel.configHandlerCode),
            callback: function($$v) {
              _vm.$set(_vm.dsModel, "configHandlerCode", $$v)
            },
            expression: "dsModel.configHandlerCode"
          }
        }), _vm._v(" "), _c('el-alert', {
          attrs: {
            "type": "info",
            "closable": false,
            "title": "}"
          }
        })], 1), _vm._v(" "), _c('el-tab-pane', {
          attrs: {
            "name": "2",
            "label": _vm.i18nt('designer.setting.dsDataHandlerTitle')
          }
        }, [_c('el-alert', {
          attrs: {
            "type": "info",
            "closable": false,
            "title": "(result, isSandbox, DSV, VFR) => {"
          }
        }), _vm._v(" "), _c('code-editor', {
          ref: "dhEditor",
          attrs: {
            "mode": 'javascript',
            "readonly": false
          },
          model: {
            value: (_vm.dsModel.dataHandlerCode),
            callback: function($$v) {
              _vm.$set(_vm.dsModel, "dataHandlerCode", $$v)
            },
            expression: "dsModel.dataHandlerCode"
          }
        }), _vm._v(" "), _c('el-alert', {
          attrs: {
            "type": "info",
            "closable": false,
            "title": "}"
          }
        })], 1), _vm._v(" "), _c('el-tab-pane', {
          attrs: {
            "name": "3",
            "label": _vm.i18nt('designer.setting.dsErrorHandlerTitle')
          }
        }, [_c('el-alert', {
          attrs: {
            "type": "info",
            "closable": false,
            "title": "(error, isSandbox, DSV, $message, VFR) => {"
          }
        }), _vm._v(" "), _c('code-editor', {
          ref: "ehEditor",
          attrs: {
            "mode": 'javascript',
            "readonly": false
          },
          model: {
            value: (_vm.dsModel.errorHandlerCode),
            callback: function($$v) {
              _vm.$set(_vm.dsModel, "errorHandlerCode", $$v)
            },
            expression: "dsModel.errorHandlerCode"
          }
        }), _vm._v(" "), _c('el-alert', {
          attrs: {
            "type": "info",
            "closable": false,
            "title": "}"
          }
        })], 1), _vm._v(" "), _c('el-tab-pane', {
          attrs: {
            "name": "4",
            "label": _vm.i18nt('designer.setting.dataSetSettingTitle')
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": _vm.i18nt('designer.setting.dataSetEnabled')
          }
        }, [_c('el-switch', {
          model: {
            value: (_vm.dsModel.dataSetEnabled),
            callback: function($$v) {
              _vm.$set(_vm.dsModel, "dataSetEnabled", $$v)
            },
            expression: "dsModel.dataSetEnabled"
          }
        })], 1), _vm._v(" "), (_vm.dsModel.dataSetEnabled) ? _c('el-form-item', {
          attrs: {
            "label": _vm.i18nt('designer.setting.dataSetSetting')
          }
        }, [_vm._l((_vm.dsModel.dataSets), function(dSet, dIdx) {
          return _c('el-row', {
            key: dIdx,
            staticClass: "rd-row",
            attrs: {
              "gutter": 8
            }
          }, [_c('el-col', {
            attrs: {
              "span": 7
            }
          }, [_c('el-form-item', {
            attrs: {
              "prop": 'dataSets.' + dIdx + '.name',
              "rules": _vm.nameRules,
              "label-width": "0"
            }
          }, [_c('el-input', {
            attrs: {
              "placeholder": _vm.i18nt('designer.setting.dsRequestNameInputPlaceholder')
            },
            model: {
              value: (dSet.name),
              callback: function($$v) {
                _vm.$set(dSet, "name", $$v)
              },
              expression: "dSet.name"
            }
          })], 1)], 1), _vm._v(" "), _c('el-col', {
            attrs: {
              "span": 8
            }
          }, [_c('el-form-item', {
            attrs: {
              "prop": 'dataSets.' + dIdx + '.remark',
              "label-width": "0"
            }
          }, [_c('el-input', {
            attrs: {
              "placeholder": _vm.i18nt('designer.setting.dataSetRemarkInputPlaceholder')
            },
            model: {
              value: (dSet.remark),
              callback: function($$v) {
                _vm.$set(dSet, "remark", $$v)
              },
              expression: "dSet.remark"
            }
          })], 1)], 1), _vm._v(" "), _c('el-col', {
            attrs: {
              "span": 3
            }
          }, [_c('el-button', {
            attrs: {
              "icon": "el-icon-delete",
              "plain": "",
              "circle": ""
            },
            on: {
              "click": function($event) {
                return _vm.deleteDataSet(dIdx)
              }
            }
          })], 1)], 1)
        }), _vm._v(" "), _c('el-row', [_c('el-col', {
          attrs: {
            "span": 6
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text",
            "icon": "el-icon-plus"
          },
          on: {
            "click": _vm.addDataSet
          }
        }, [_vm._v("\n                    " + _vm._s(_vm.i18nt('designer.setting.addDataSet')))])], 1)], 1)], 2) : _vm._e()], 1)], 1)], 1)]
      },
      proxy: true
    }, {
      key: "footer",
      fn: function() {
        return [_c('div', {
          staticClass: "dialog-footer"
        })]
      },
      proxy: true
    }], null, false, 2285160442)
  }) : _vm._e(), _vm._v(" "), (_vm.showTestDataSourceDialogFlag) ? _c('el-dialog', {
    attrs: {
      "title": _vm.i18nt('designer.setting.testDataSource'),
      "visible": _vm.showTestDataSourceDialogFlag,
      "show-close": true,
      "custom-class": "drag-dialog small-padding-dialog",
      "append-to-body": "",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "destroy-on-close": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showTestDataSourceDialogFlag = $event
      }
    }
  }, [_c('el-alert', {
    attrs: {
      "type": "info",
      "closable": false,
      "title": _vm.i18nt('designer.setting.dsvTitle')
    }
  }), _vm._v(" "), _c('code-editor', {
    staticClass: "dsv-json-editor",
    attrs: {
      "mode": 'json',
      "readonly": false
    },
    model: {
      value: (_vm.dsvJson),
      callback: function($$v) {
        _vm.dsvJson = $$v
      },
      expression: "dsvJson"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.doDataSourceRequest
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.executeDataSource')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.clearRequestResult
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.clearRequestResult')))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.showTestDataSourceDialogFlag = false
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18nt('designer.hint.closePreview')))])], 1), _vm._v(" "), _c('el-alert', {
    attrs: {
      "type": "info",
      "closable": false,
      "title": _vm.i18nt('designer.setting.dsRequestResult')
    }
  }), _vm._v(" "), _c('code-editor', {
    ref: "dsResultEditor",
    attrs: {
      "mode": 'json',
      "readonly": true
    },
    model: {
      value: (_vm.dsResultJson),
      callback: function($$v) {
        _vm.dsResultJson = $$v
      },
      expression: "dsResultJson"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showImportDSDialogFlag) ? _c('el-dialog', {
    directives: [{
      name: "dialog-drag",
      rawName: "v-dialog-drag"
    }],
    staticClass: "small-padding-dialog",
    attrs: {
      "title": _vm.i18nt('designer.setting.importDataSource'),
      "visible": _vm.showImportDSDialogFlag,
      "show-close": true,
      "center": "",
      "append-to-body": "",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "destroy-on-close": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showImportDSDialogFlag = $event
      }
    }
  }, [_c('el-alert', {
    staticClass: "alert-padding",
    attrs: {
      "type": "info",
      "title": _vm.i18nt('designer.hint.importDSHint'),
      "show-icon": ""
    }
  }), _vm._v(" "), _c('code-editor', {
    attrs: {
      "mode": 'json',
      "readonly": false
    },
    model: {
      value: (_vm.importDSTemplate),
      callback: function($$v) {
        _vm.importDSTemplate = $$v
      },
      expression: "importDSTemplate"
    }
  }), _vm._v(" "), _c('el-switch', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "active-text": _vm.i18nt('designer.setting.clearExistingDataSource'),
      "inactive-text": _vm.i18nt('designer.setting.remainExistingDataSource')
    },
    model: {
      value: (_vm.clearOldDSFlag),
      callback: function($$v) {
        _vm.clearOldDSFlag = $$v
      },
      expression: "clearOldDSFlag"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.doImportDataSource
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18nt('designer.hint.import')))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.showImportDSDialogFlag = false
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18nt('designer.hint.cancel')))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showExportDSDialogFlag) ? _c('el-dialog', {
    directives: [{
      name: "dialog-drag",
      rawName: "v-dialog-drag"
    }],
    staticClass: "small-padding-dialog",
    attrs: {
      "title": _vm.i18nt('designer.setting.exportDataSource'),
      "visible": _vm.showExportDSDialogFlag,
      "append-to-body": "",
      "show-close": true,
      "center": "",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "destroy-on-close": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showExportDSDialogFlag = $event
      }
    }
  }, [_c('el-tabs', {
    staticClass: "no-box-shadow no-padding",
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleExportTabClick
    },
    model: {
      value: (_vm.activeExportTab),
      callback: function($$v) {
        _vm.activeExportTab = $$v
      },
      expression: "activeExportTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.i18nt('designer.setting.selectDataSourceForExport'),
      "name": "setting"
    }
  }, [(_vm.exportDSArray && (_vm.exportDSArray.length > 0)) ? _c('div', {
    staticClass: "export-ds-list"
  }, _vm._l((_vm.exportDSArray), function(ds, dsIdx) {
    return _c('el-descriptions', {
      key: dsIdx,
      attrs: {
        "column": 1,
        "size": "small",
        "border": ""
      },
      scopedSlots: _vm._u([{
        key: "title",
        fn: function() {
          return [_c('span', {
            attrs: {
              "title": ds.description
            }
          }, [_vm._v(_vm._s(ds.uniqueName))])]
        },
        proxy: true
      }, {
        key: "extra",
        fn: function() {
          return [_c('el-checkbox', {
            on: {
              "change": _vm.handleExportDSChange
            },
            model: {
              value: (ds.checked),
              callback: function($$v) {
                _vm.$set(ds, "checked", $$v)
              },
              expression: "ds.checked"
            }
          }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.dataSourceChecked')))])]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _vm._v(" "), _c('el-descriptions-item', [_c('template', {
      slot: "label"
    }, [_c('i', {
      staticClass: "el-icon-s-platform",
      attrs: {
        "title": ds.requestURL
      }
    })]), _vm._v("\n              " + _vm._s(ds.requestURL) + "\n            ")], 2)], 1)
  }), 1) : [_c('el-empty', {
    attrs: {
      "description": _vm.i18nt('designer.setting.noDataSource')
    }
  })]], 2), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.i18nt('designer.setting.previewDataSourceExportResult'),
      "name": "result"
    }
  }, [_c('code-editor', {
    ref: "exportDSEditor",
    attrs: {
      "mode": 'json',
      "readonly": true
    },
    model: {
      value: (_vm.dsExportContent),
      callback: function($$v) {
        _vm.dsExportContent = $$v
      },
      expression: "dsExportContent"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "copy-json-btn",
    attrs: {
      "type": "primary",
      "data-clipboard-text": _vm.dsRawExportContent
    },
    on: {
      "click": _vm.copyDataSourceJson
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18nt('designer.hint.copyJson')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": function($event) {
        _vm.showExportDSDialogFlag = false
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18nt('designer.hint.closePreview')))])], 1)], 1) : _vm._e()], 2)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73e367a1","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/setting-panel/data-source-setting.vue
// module id = null
// module chunks = 